export const MAX_NUMBER_MESSAGES = 100;
